import { createAllPins } from '../board/CreateAllPins';
import fall from './Fall';
import nextStep from './next/NextStep';
import handleCoordinates from './C/HandleCoordinates';
import handleTween from './handlers/HandleTween';
import handleFinalTouchAngle from './touch/HandleFinalTouchAngle';
import starting from './Starting';
import final from './Final';
import c0coordinates from './C/C0coordinates';
import c1coordinates from './C/C1coordinates';
import draw from './Draw';
import nextDirection from './next/NextDirection';
import { backgrounds } from '../board/constants/backgrounds';
class Ball {
  constructor(
    x,
    y,
    path,
    ctx,
    rows,
    removeBall,
    coeffs,
    handleFinish,
    speed,
    ballBalance,
    ballWin
  ) {
    this.p0 = { x: null, y: null };
    this.c0 = { x: null, y: null };
    this.c1 = { x: null, y: null };
    this.p1 = { x: null, y: null };
    this.movePath = path;
    this.ball = { x: x, y: y }; // ball falling points
    this.ctx = ctx;
    this.rows = rows;
    this.board = createAllPins(rows, 315);
    this.ballRadius = this.board[0][0].ballR;
    this.pinRadius = this.board[0][0].r;
    this.fisrtPinY = this.board[0][1].y;
    this.removeBall = removeBall;
    this.coeffs = coeffs;
    this.coef = {
      coef: this.coeffs[
        path.reduce((accumulator, element) => accumulator + +element, 0)
      ],
      background:
        backgrounds[rows - 8][
          path.reduce((accumulator, element) => accumulator + +element, 0)
        ],
    };
    this.hide = false;
    this.handleFinish = handleFinish;
    // this.vd = [0, 0, 0, 0, 0, 0, 22, 20, 20][rows - 7];
    this.fall = fall.bind(this);
    this.nextStep = nextStep.bind(this);
    this.nextDirection = nextDirection.bind(this);
    this.handleCoordinates = handleCoordinates.bind(this);
    this.handleTween = handleTween.bind(this);
    this.handleFinalTouchAngle = handleFinalTouchAngle.bind(this);
    this.starting = starting.bind(this);
    this.final = final.bind(this);
    this.c0coordinates = c0coordinates.bind(this);
    this.c1coordinates = c1coordinates.bind(this);
    this.draw = draw.bind(this);
    this.sameRowOn = [];
    this.speed = speed;
    this.startingAngle = 90;
    this.ballBalance = ballBalance;
    this.ballWin = ballWin;
  }

  anims = [];
  row = 0;
  column = 1;
}

export default Ball;
